<template>
    <el-form ref="loginRef" :model="loginForm" :rules="rules">
        <h4>Hello, Welcome back!</h4>
        <br />
        <el-form-item prop="email">
            <el-input
                v-model="loginForm.email"
                placeholder="Email"
                :prefix-icon="Message"
            ></el-input>
        </el-form-item>
        <el-form-item prop="password">
            <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="Password"
                :prefix-icon="Lock"
            ></el-input>
        </el-form-item>
        <div class="mb-4">
            <router-link :to="{ name: 'ForgotPassword' }">
                Forgot Password
            </router-link>
        </div>
        <AppErrorField :error="errorMsg" /><br />
        <el-form-item>
            <el-button class="w-100" type="primary" @click="login">
                LOGIN
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script lang="ts">
import AppErrorField from '@/components/AppErrorField.vue';
import { Auth } from 'aws-amplify';
import { defineComponent, ref, reactive, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { Message, Lock } from '@element-plus/icons';
import { useStore } from 'vuex';

interface LoginStruct {
    email: string;
    password: string | undefined;
}

const Login = defineComponent({
    components: {
        AppErrorField,
    },
    setup() {
        const router = useRouter();
        const store = useStore();
        const loginData = reactive({
            loginForm: {
                email: '',
                password: '',
            } as LoginStruct,
            loginRef: ref(),
            errorMsg: ref<string | null>(null),
            rules: {
                email: [
                    {
                        required: true,
                        message: 'Please input email address',
                        trigger: ['blur'],
                    },
                    {
                        type: 'email',
                        message: 'Please input correct email address',
                        trigger: ['blur', 'change'],
                    },
                ],
                password: [
                    {
                        required: true,
                        message: 'Please input the password',
                        trigger: ['blur'],
                    },
                ],
            } as any,
        });

        const login = () => {
            loginData.loginRef.validate(async (valid: boolean) => {
                if (valid) {
                    try {
                        const user = await Auth.signIn(
                            loginData.loginForm.email,
                            loginData.loginForm.password,
                        );
                        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                            store.commit('auth/SET_LOGGED', user);
                            await router.push({
                                name: 'NewPassword',
                            });
                        } else {
                            store.commit('auth/SET_LOGGED', user);
                            await router.push('/');
                        }
                    } catch (err: any) {
                        loginData.errorMsg = err.message;
                    }
                } else {
                    return false;
                }
            });
        };

        return {
            ...toRefs(loginData),
            login,
            Message,
            Lock,
        };
    },
});
export default Login;
</script>
<style>
.h-100 {
    height: 100%;
}
.w-100 {
    width: 100%;
}
</style>
